import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'

import ContractLoader from './_load/ContractLoader'
import ModalContent from './ModalContent'

const ShowUserModal = props => {
  return (
    <ControlledModal width="48rem" {...props}>
      <ContractLoader>
        <ModalContent />
      </ContractLoader>
    </ControlledModal>
  )
}

export default ShowUserModal
